import { logComponentError } from '@ms/yammer-diagnostics-state';
import type { EcsPersistKey } from '@ms/yammer-libs-static-config';
import { reportError } from '@ms/yammer-telemetry';

import { writeLegacyEcsPersistedState } from './persistence';
import type { EcsSourceSnapshot, ExperimentsState } from './store';
import { experimentsStore } from './store';

export interface EcsPersistenceWriteController {
  readonly dispose: () => void;
}

const selectSourceSnapshot = (state: ExperimentsState): EcsSourceSnapshot => ({
  ecsConfig: state.ecsConfig,
  experimentTreatmentsFromService: state.experimentTreatmentsFromService,
  experimentTreatmentOverrides: state.experimentTreatmentOverrides,
  featureRolloutTreatmentsFromService: state.featureRolloutTreatmentsFromService,
  featureRolloutTreatmentOverrides: state.featureRolloutTreatmentOverrides,
});

const hasSourceSnapshotChanged = (state: ExperimentsState, previousState: ExperimentsState): boolean =>
  state.ecsConfig !== previousState.ecsConfig ||
  state.experimentTreatmentsFromService !== previousState.experimentTreatmentsFromService ||
  state.experimentTreatmentOverrides !== previousState.experimentTreatmentOverrides ||
  state.featureRolloutTreatmentsFromService !== previousState.featureRolloutTreatmentsFromService ||
  state.featureRolloutTreatmentOverrides !== previousState.featureRolloutTreatmentOverrides;

const reportPersistenceWriteFailure = (error: unknown): void => {
  logComponentError('Experiments', error);
  reportError({ error });
};

export const createEcsPersistenceWriteController = (persistKey: EcsPersistKey): EcsPersistenceWriteController => {
  const unsubscribe = experimentsStore.subscribe((state, previousState) => {
    if (hasSourceSnapshotChanged(state, previousState)) {
      try {
        writeLegacyEcsPersistedState(persistKey, selectSourceSnapshot(state));
      } catch (error) {
        reportPersistenceWriteFailure(error);
      }
    }
  });

  return {
    dispose: unsubscribe,
  };
};
